import { Component } from '@angular/core';

@Component({
  selector: 'mc-scheduling-new',
  templateUrl: './scheduling-new.component.html',
  styleUrls: ['./scheduling-new.component.scss']
})
export class SchedulingNewComponent {
  constructor() { }
}
